/* eslint-disable no-new */
import * as utilReportMasterProduk from '@/api/reportMasterProduk'
import * as utilReportMasterKontak from '@/api/reportMasterKontak'
import * as utilReportMasterPromo from '@/api/reportMasterPromo'
const actions = {
  listDataMasterProduk({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportMasterProduk.listDataMasterProduk(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listDataMasterKontak({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportMasterKontak.listDataMasterKontak(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  listDataMasterPromo({
    commit
  }, dataParams) {
    // console.log('dataParams', dataParams)
    return new Promise((resolve, reject) => {
      utilReportMasterPromo.listDataMasterPromo(dataParams).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reportDataMaster.js